import React from "react";
import Lottie from "react-lottie";
import grey_loading from "../../../assets/lottie/grey-spinner.json";
import blue_loading from "../../../assets/lottie/blue-spinner.json";
import styled from "@emotion/styled";

const CircleLoading = (props) => {
    // css style
    const {view} = useComponentStyle(props.size);

    return (
        <view.LoadingSpinner>
            <Lottie
                options={{
                    loop: true,
                    autoPlay: true,
                    animationData: props.size === "sm" ? grey_loading : blue_loading,
                }}
            />
        </view.LoadingSpinner>
    );
};

export default CircleLoading;

export const useComponentStyle = (size) => {
    return {
        view: {
            LoadingSpinner: styled.div({
                display: "inline-block",
                width: size === "sm" ? "50px" : "250px",
                height: size === "sm" ? "50px" : "250px",
            }),
        },
    };
};
